module.exports = __webpack_public_path__ + "static/media/loc1_img23.fb43f1c7.jpg";